import { useLightMode } from '@/hooks/useLightMode'

import { Notification } from '@/graphql/appsync-notifications'

import { getNotificationToastTokens } from '../styles/tokens'
import { ClearNotificationTitle } from './ClearNotificationTitle'
import { NotificationSubtitle } from './NotificationSubtitle'
import { NotificationToastShell } from './NotificationToastShell'

export const ClearNotification = ({
  notification,
  onCancel,
}: {
  notification: Notification
  onCancel?: (incidentTimeStamp: string) => void
}) => {
  const tokens = getNotificationToastTokens(useLightMode())
  return (
    <NotificationToastShell
      accentColor={tokens.success}
      notificationTimestamp={notification?.notificationTimestamp}
      onCancel={onCancel}
    >
      <ClearNotificationTitle notification={notification} />
      <NotificationSubtitle
        facilityShortName={notification?.facilityShortName}
        sourceName={notification?.incidentSourceName}
        timestamp={notification?.notificationTimestamp}
      />
    </NotificationToastShell>
  )
}
